"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeUserInteractionTracker = void 0;
// this is wrong namely it is not related at all to react.
var react_hotjar_1 = require("react-hotjar");
var ID;
var VERSION;
var isUserInteractionTrackerInitialized;
/**
 * @deprecated Use fullstory instead.
 */
var initializeUserInteractionTracker = function (_a) {
    var hotjarCredentials = _a.credentials;
    if (!hotjarCredentials) {
        throw Error('credentials are mandatory');
    }
    if (!isUserInteractionTrackerInitialized) {
        ID = hotjarCredentials.id;
        VERSION = hotjarCredentials.version;
        isUserInteractionTrackerInitialized = true;
        react_hotjar_1.hotjar.initialize(ID, VERSION);
    }
};
exports.initializeUserInteractionTracker = initializeUserInteractionTracker;
//# sourceMappingURL=index.js.map